<template>
  <section>
    <div class="bg-white px-12 py-12 w-full lg:max-w-[510px] mx-auto">
      <h1 autofocus="false" aria-selected="false"
        class="mx-auto w-full px-1 py-2 text-center font-extrabold text-[#000000] [font-size:_clamp(.7em,2vw,1em)] sm:w-[70%]">
        {{ $t("general.payment_gateway") }}
      </h1>
      <section class="mt-2 flex flex-col gap-y-1">
        <div v-for="option in paymentMethodOptions" :key="option.method">
          <label :for="`payment-option-${option.method}`"
            class="flex cursor-pointer items-center justify-between rounded-md border p-3">
            <legend class="flex items-center justify-start gap-3 ml-6">
              <div v-html="option.icon" class="w-13"></div>
              <span class="block text-sm font-medium text-gray-900">
                {{ option.text }}
              </span>
            </legend>
            <input :id="`payment-option-${option.method}`" type="radio" name="payment-method" :value="option.method"
              v-model="paymentMethod" class="h-4 w-4 border-gray-300 focus:ring-2 focus:ring-blue-300"
              :aria-labelledby="`payment-option-${option.method}`"
              :aria-describedby="`payment-option-${option.method}`" />
          </label>
          <div v-if="paymentMethod == 'mobile_wallet' && option.method == 'mobile_wallet'" class="mb-3">
            <CustomVueTelInput :onChange="onChangePhone" className="w-full sm:w-[80%]" placeholder="ادخل رقم المحفظة" />
            <p v-for="(error, index) of v$.phone.$errors" :key="error.uid"
              class="mt-1 pr-2 text-sm text-red-600 ltr:pl-2 ltr:pr-0">
              {{ index == 0 ? error.$message : "" }}
            </p>
          </div>
        </div>
      </section>
      <footer class=" mt-2 flex flex-col gap-3  items-center justify-between sm:gap-6 sm:flex-row sm:h-[50px]">
        <button @click="type == 'upgrade' ? handleUpgrade() : handleCheckout()" :disabled="isProcessing"
          class="h-full w-full rounded-md bg-primary py-4 text-sm text-white sm:py-1 hover:opacity-50 disabled:opacity-50">
          {{ isProcessing ? $t("general.loading") : `${$t("general.confirm")}` }}
        </button>

      </footer>

    </div>
  </section>
</template>

<script>
import Dialog from "@/components/ui/Dialog";
import CustomVueTelInput from "@/components/ui/CustomVueTelInput";
import useVuelidate from "@vuelidate/core";
export default {
  props:['currentStoreId','type'],
  components: {
    CustomVueTelInput,
    Dialog,
  },
  setup() {

    return {

      router: useRouter(),
      route: useRoute(),

    };
  },

  data() {
    return {
      v$: useVuelidate(),
      phone: null,
      isProcessing: false,
      isModalOpen: false,
      paymentMethod: null,
      packageData: null,
      paymentMethodOptions: [
        {
          method: "card",
          text: "البطاقة الائتمانية",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="46.738" height="15.126" viewBox="0 0 46.738 15.126">
                    <g id="visa" transform="translate(-81.166 -105.048)">
                      <path id="polygon9" d="M437.293,125.369h-3.786l2.368-14.642h3.786Z" transform="translate(-335.874 -5.414)" fill="#00579f"/>
                      <path id="path11" d="M576.536,105.671a9.331,9.331,0,0,0-3.4-.623c-3.739,0-6.372,1.994-6.388,4.844-.031,2.1,1.885,3.271,3.318,3.972,1.465.717,1.963,1.184,1.963,1.823-.015.981-1.184,1.433-2.274,1.433a7.535,7.535,0,0,1-3.552-.779l-.5-.234-.53,3.287a11.523,11.523,0,0,0,4.222.779c3.973,0,6.559-1.963,6.59-5,.015-1.667-1-2.944-3.178-3.988-1.324-.67-2.135-1.122-2.135-1.807.016-.623.686-1.261,2.181-1.261a6.433,6.433,0,0,1,2.82.561l.342.155.515-3.162Z" transform="translate(-461.392 0)" fill="#00579f"/>
                      <path id="path13" d="M796.38,120.182c.312-.841,1.512-4.1,1.512-4.1-.016.031.311-.857.5-1.4l.265,1.262s.717,3.5.873,4.237Zm4.673-9.455h-2.929a1.868,1.868,0,0,0-1.979,1.215l-5.624,13.427h3.973l.795-2.2h4.861c.109.514.452,2.2.452,2.2h3.506l-3.054-14.642Z" transform="translate(-676.204 -5.414)" fill="#00579f"/>
                      <path id="path15" d="M175.183,110.727l-3.708,9.985-.405-2.025a11.207,11.207,0,0,0-5.235-6.138l3.4,12.8h4l5.951-14.627Z" transform="translate(-80.713 -5.414)" fill="#00579f"/>
                      <path id="path17" d="M87.319,110.727H81.228l-.062.3c4.752,1.215,7.9,4.144,9.192,7.665l-1.324-6.73a1.567,1.567,0,0,0-1.714-1.231Z" transform="translate(0 -5.414)" fill="#faa61a"/>
                    </g>
                  </svg>`,
        },
        {
          method: "mobile_wallet",
          text: "المحفظة الإلكترونية",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="23.102" height="21.179" viewBox="0 0 23.102 21.179">
                    <g id="Wallet" transform="translate(-0.25 -0.852)">
                      <path id="Path_19785" data-name="Path 19785" d="M20.2,20.6H3.4A2.4,2.4,0,0,1,1,18.2V7.4A2.4,2.4,0,0,1,3.4,5H20.2a2.4,2.4,0,0,1,2.4,2.4V18.2a2.4,2.4,0,0,1-2.4,2.4Z" transform="translate(0 0.68)" fill="none" stroke="#0963ff" stroke-width="1.5"/>
                      <path id="Path_19786" data-name="Path 19786" d="M14.6,12.2a.6.6,0,1,1,.424-.176A.6.6,0,0,1,14.6,12.2Z" transform="translate(2.602 1.88)" fill="#0963ff" stroke="#0963ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                      <path id="Path_19787" data-name="Path 19787" d="M19,5.68V4a2.4,2.4,0,0,0-3.018-2.319L2.782,5.2A2.4,2.4,0,0,0,1,7.524V8.08" transform="translate(0)" fill="none" stroke="#0963ff" stroke-width="1.5"/>
                    </g>
                  </svg>`,
        },
        // {
        //   method: "google_pay",
        //   text: "جوجل باي",
        //   icon: `<svg width="27" height="21.179" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
        //                 viewBox="0 0 2387.3 948" xml:space="preserve">
        //               <style type="text/css">
        //                 .st0{fill:#5F6368;}
        //                 .st1{fill:#4285F4;}
        //                 .st2{fill:#34A853;}
        //                 .st3{fill:#FBBC04;}
        //                 .st4{fill:#EA4335;}
        //               </style>
        //               <g>
        //                 <path class="st0" d="M1129.1,463.2V741h-88.2V54.8h233.8c56.4-1.2,110.9,20.2,151.4,59.4c41,36.9,64.1,89.7,63.2,144.8
        //                   c1.2,55.5-21.9,108.7-63.2,145.7c-40.9,39-91.4,58.5-151.4,58.4L1129.1,463.2L1129.1,463.2z M1129.1,139.3v239.6h147.8
        //                   c32.8,1,64.4-11.9,87.2-35.5c46.3-45,47.4-119.1,2.3-165.4c-0.8-0.8-1.5-1.6-2.3-2.3c-22.5-24.1-54.3-37.3-87.2-36.4L1129.1,139.3
        //                   L1129.1,139.3z M1692.5,256.2c65.2,0,116.6,17.4,154.3,52.2c37.7,34.8,56.5,82.6,56.5,143.2V741H1819v-65.2h-3.8
        //                   c-36.5,53.7-85.1,80.5-145.7,80.5c-51.7,0-95-15.3-129.8-46c-33.8-28.5-53-70.7-52.2-115c0-48.6,18.4-87.2,55.1-115.9
        //                   c36.7-28.7,85.7-43.1,147.1-43.1c52.3,0,95.5,9.6,129.3,28.7v-20.2c0.2-30.2-13.2-58.8-36.4-78c-23.3-21-53.7-32.5-85.1-32.1
        //                   c-49.2,0-88.2,20.8-116.9,62.3l-77.6-48.9C1545.6,286.8,1608.8,256.2,1692.5,256.2L1692.5,256.2z M1578.4,597.3
        //                   c-0.1,22.8,10.8,44.2,29.2,57.5c19.5,15.3,43.7,23.5,68.5,23c37.2-0.1,72.9-14.9,99.2-41.2c29.2-27.5,43.8-59.7,43.8-96.8
        //                   c-27.5-21.9-65.8-32.9-115-32.9c-35.8,0-65.7,8.6-89.6,25.9C1590.4,550.4,1578.4,571.7,1578.4,597.3L1578.4,597.3z M2387.3,271.5
        //                   L2093,948h-91l109.2-236.7l-193.6-439.8h95.8l139.9,337.3h1.9l136.1-337.3L2387.3,271.5z"/>
        //               </g>
        //               <path class="st1" d="M772.8,403.2c0-26.9-2.2-53.7-6.8-80.2H394.2v151.8h212.9c-8.8,49-37.2,92.3-78.7,119.8v98.6h127.1
        //                 C729.9,624.7,772.8,523.2,772.8,403.2L772.8,403.2z"/>
        //               <path class="st2" d="M394.2,788.5c106.4,0,196-34.9,261.3-95.2l-127.1-98.6c-35.4,24-80.9,37.7-134.2,37.7
        //                 c-102.8,0-190.1-69.3-221.3-162.7H42v101.6C108.9,704.5,245.2,788.5,394.2,788.5z"/>
        //               <path class="st3" d="M172.9,469.7c-16.5-48.9-16.5-102,0-150.9V217.2H42c-56,111.4-56,242.7,0,354.1L172.9,469.7z"/>
        //               <path class="st4" d="M394.2,156.1c56.2-0.9,110.5,20.3,151.2,59.1L658,102.7C586.6,35.7,492.1-1.1,394.2,0
        //                 C245.2,0,108.9,84.1,42,217.2l130.9,101.6C204.1,225.4,291.4,156.1,394.2,156.1z"/>
        //               </svg>`,
        // },
        {
          method: "credit_wallet",
          text: "محفظة سيزما",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="23.102" height="21.179" viewBox="0 0 23.102 21.179">
                    <g id="Wallet" transform="translate(-0.25 -0.852)">
                      <path id="Path_19785" data-name="Path 19785" d="M20.2,20.6H3.4A2.4,2.4,0,0,1,1,18.2V7.4A2.4,2.4,0,0,1,3.4,5H20.2a2.4,2.4,0,0,1,2.4,2.4V18.2a2.4,2.4,0,0,1-2.4,2.4Z" transform="translate(0 0.68)" fill="none" stroke="#0963ff" stroke-width="1.5"/>
                      <path id="Path_19786" data-name="Path 19786" d="M14.6,12.2a.6.6,0,1,1,.424-.176A.6.6,0,0,1,14.6,12.2Z" transform="translate(2.602 1.88)" fill="#0963ff" stroke="#0963ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                      <path id="Path_19787" data-name="Path 19787" d="M19,5.68V4a2.4,2.4,0,0,0-3.018-2.319L2.782,5.2A2.4,2.4,0,0,0,1,7.524V8.08" transform="translate(0)" fill="none" stroke="#0963ff" stroke-width="1.5"/>
                    </g>
                  </svg>`,
        },
      ],
    };
  },
  validations() {
    return {
      phone:

        { ...this.VALIDATIONS.phone }
    };
  },
  mounted() {
    const storedObject = JSON.parse(sessionStorage.getItem('upgrade'));

    if (!(storedObject)) this.$router.replace(this.ROUTESNAMES.user.upgrade);

    this.packageData = storedObject;

  },
 
  computed: {


  },
  methods: {


    onChangePhone(val) {
      this.phone = val;
    },
    handleUpgrade(){
      this.paymentMethod == "mobile_wallet" ? this.v$.$touch() : "";
      if (!this.paymentMethod) {
        this.notify({ type: 'error', msg: this.$t('general.choose_payment_method') });
        return;
      }

      if (this.v$.phone.$error && this.paymentMethod == "mobile_wallet") return;
      const payload = {
        package_id: this.packageData?.packageId,
        payment_method: this.paymentMethod,
        store_id: this.currentStoreId
      }
      if (this.packageData?.couponId) {
        payload.coupon_id = this.packageData?.couponId
      }
      if (this.phone) payload.phone = this.phone

      this.isProcessing = true;
      this.makeRequest({
        owner: this.MAINROLES.user,
        url: this.APIREQUESTS.panel.storeUpgrade.url,
        method: this.APIREQUESTS.panel.storeUpgrade.method,
        formData: payload
      }).then((res)=>{
        if(!res?.status){
          this.notify({type:"error",msg:res?.message || this.$t("general.failed")});
        } else {
          //succeeded
          if(res?.data?.payment_url != null && payload?.payment_method != 'credit_wallet'){
            window.open(res?.data?.payment_url, '_blank');
            this.$router.go();
          } else {
            if(payload?.payment_method == 'credit_wallet'){
              this.notify({ type: "success", msg: this.$t("general.payment_is_done_successfully") });
              this.$router.go();
            }else{
              this.notify({ type: "error", msg: res?.message || this.$t("general.failed") });
            }
          }
        }
      }).catch((err)=>{
        this.notify({type:"error",msg:err?.data?.message || this.$t("general.unknown_error")});
      }).finally(()=>{
        this.isProcessing = false;
      })
    },

    async handleCheckout() {

      this.paymentMethod == "mobile_wallet" ? this.v$.$touch() : "";
      if (!this.paymentMethod) {
        this.notify({ type: 'error', msg: this.$t('general.choose_payment_method') });
        return;
      }

      if (this.v$.phone.$error && this.paymentMethod == "mobile_wallet") return;


      const payload = {
        package_id: this.packageData?.packageId,
        payment_method: this.paymentMethod,
      }
      if (this.packageData?.couponId) {
        payload.coupon_id = this.packageData?.couponId
      }
      if (this.phone) payload.phone = this.phone

      localStorage.setItem('allowToCreate', JSON.stringify(true));


      this.useLocalStorage({ type: 'set', key: 'allowToCreate', value: true }); //permission to access page store-settings/create


      this.isProcessing = true
      this.makeRequest({
          owner: this.MAINROLES.user,
          url: this.APIREQUESTS.reseller.storeCheckout.url,
          method: this.APIREQUESTS.reseller.storeCheckout.method,
          formData: payload
      })
          .then((res) => {
              if (!res || !res?.hasOwnProperty('status')) {
                  return;
              } else if (!res?.status) {
                  this.notify({ type: 'error', msg: res.message, });
              } else {
                  // succeeded


                  if(this.paymentMethod == 'credit_wallet'){
                      this.notify({ type: 'success', msg: this.$t('general.payment_is_done_successfully') });
                      this.$router.replace(`${this.ROUTESNAMES.user.storeSettings}/create`)
                  }else if (Number(this.discount?.percent) === 100) {
                      this.notify({ type: 'success', msg: this.$t('general.done_successfully'), });
                      // no need to payment and goto create store
                      // goto create store
                      this.$router.replace(`${this.ROUTESNAMES.user.storeSettings}/create`)
                  } else {
                      this.notify({ type: 'success', msg: this.$t('general.done_successfully'), });
                      // need to payment 
                      // this.$router.replace(`${this.ROUTESNAMES.user.storeSettings}/create`)
                     
                      this.useLocalStorage({ type: 'set', key: 'payment_type', value: 'create' });
                      window.open(res?.data?.payment_url, "_blank")
                  }
                  //after payment success --->
                  //some changes in user in local, upgrade user to reseller and add selectedPackage 
                  let user = this.useLocalStorage({ type: "get", key: 'user' });

                  user = {
                      ...user,
                      role: 'reseller',//change role of user to reseller untill login again to change user object form response
                      selectedPackage: this.packageData || {},//save package that reseller was selected in localstorage, 
                      packageWasSelected: true,//permission to access page store-settings/create
                  }
                  this.useLocalStorage({ type: 'set', key: 'user', value: user });
                  // this.useLocalStorage({ type: 'set', key: 'allowToCreate', value: true }); //permission to access page store-settings/create
              }
          })
          .catch((err) => { //not succeeded
              // console.error(err);
              //case of Unauthenticated
              this.notify({
                  type: 'error',
                  msg: err?.data?.message || this.$t("general.unknown_error"),
              });
          }).finally(() => {
              this.isProcessing = false
              // this.setCouponState('init')
              this.closePaymentModal()
          })



    },
  },
};
</script>

<style></style>